import { createContext, useContext } from "react";

// ViewTableRow's comparator ignores table.options.meta, so a scalar there would
// leave every row except the one that just mutated showing a stale menu.
export const NestedEditorIsWritingContext = createContext(false);

export const useNestedEditorIsWriting = (): boolean =>
    useContext(NestedEditorIsWritingContext);
